import React, {useMemo} from 'react';
import {Link} from "react-router-dom";
import {useTable, usePagination, useSortBy, useGlobalFilter} from "react-table";
import {COLUMNS} from "./columns/coursesStudentViewColumns";
import './table.scss';
import MoreTableButton from "../../ui-components/MoreTableButton/MoreTableButton";

function CoursesStudentView(props) {

    const columns = useMemo(() => COLUMNS, []);
    const data = props.data;

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
    } = useTable({
        columns: columns,
        data: data,
        initialState: { pageSize: 9999 }
    }, useGlobalFilter, useSortBy, usePagination);

    function cellContentHandler(columnTitle, content, id){

        //Details
        if(columnTitle === "Details"){
            return(
                <Link to={"course/" + id}>
                    <MoreTableButton>Details</MoreTableButton>
                </Link>
            )
        }
        return content
    }


    return (
        <div className={'table_container'}>
            <div className={'table_container_padding'}>

                <table {...getTableProps()}>
                    <thead>
                    {headerGroups.map((headerGroup, i) =>(
                        <tr {...headerGroup.getHeaderGroupProps} key={i}>
                            {headerGroup.headers.map((column, i) => (
                                <th {...column.getHeaderProps(column.getSortByToggleProps())} key={i}>
                                    {column.render('Header')}
                                    <span>
                                    {column.isSorted
                                        ? column.isSortedDesc
                                            ? ' 🔽'
                                            : ' 🔼'
                                        : ''}
                                </span>
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page.map(row => {
                        prepareRow(row)
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map((cell, i) => {
                                    return <td{...cell.getCellProps()} key={cell.getCellProps().key}>
                                        {cellContentHandler(cell.column.Header, cell.render('Cell'), row.original.id)}
                                    </td>
                                })}
                            </tr>
                        )
                    })}
                    </tbody>

                </table>
            </div>
        </div>
    )
}

export default CoursesStudentView;